/**
 * 匹配数据模型
 * 此处数据即可以是数据服务的数据模型，也可以是事件流的数据模型
 */

export function matchModel(input: string) {
  // tslint:disable-next-line
  const matched = input.match(/^([A-Za-z_]+[A-Za-z_\d]*(\.[A-Za-z_]+[A-Za-z_\d]*)+)\(\s*([A-Za-z_]+[A-Za-z_\d]*(\[\])?(\.[A-Za-z_]+[A-Za-z_\d]*(\[\])?)*)\s*\)/);

  if (matched) {
    return {
      type: 'ModelProperty',
      raw: matched[0],
      dsl: matched[0],
      model: matched[1],
      path: matched[3],
      isAtom: true,
      isModelProperty: true
    };
  }
}
